import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const ComplianceMasterTabs = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const tabs = [
        {
            name: "PT Master",
            path: "/setting/compliance-master/pt-master",
        },
        {
            name: "LWF Master",
            path: "/setting/compliance-master/lwf-master",
        },
        {
            name: "Minimum Wages",
            path: "/setting/compliance-master/minimum-wages",
        },
    ];

    useEffect(() => {
        const isValidPath = tabs.some(
            (tab) =>
                location.pathname === tab.path ||
                location.pathname.startsWith(`${tab.path}/`)
        );

        if (!isValidPath) {
            navigate(tabs[0].path, { replace: true });
        }
    }, [location.pathname, navigate]);

    return (
        <ul className="nav nav-tabs" role="tablist">
            {tabs.map((tab) => {
                const isActive =
                    location.pathname === tab.path ||
                    location.pathname.startsWith(`${tab.path}/`);

                return (
                    <li className="nav-item" key={tab.path}>
                        <button
                            type="button"
                            className={`nav-link ${isActive ? "active" : ""}`}
                            onClick={() => navigate(tab.path)}
                        >
                            {tab.name}
                        </button>
                    </li>
                );
            })}
        </ul>
    );
};

export default ComplianceMasterTabs;